import React from 'react';
import { PageTitleZoneNext } from '../../../../components/page-title-zone';

export interface IEducatorTitlezoneProps {
  isEditMode: boolean;
}

export function EducatorTitlezone(props: IEducatorTitlezoneProps) {
  const { isEditMode } = props;
  const title = isEditMode ? 'Redigér underviser' : 'Opret underviser';
  return <PageTitleZoneNext isLoading={false} entityName="Underviser" title={title} />;
}
